export default "__VITE_ASSET__b7c87266__"